import { ChangeDetectorRef, Component } from '@angular/core';
import { BasePlugin } from '../../base-plugin.component';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models';
import { InstallationCustomerInfoPluginService } from './customer-info.service';

@Component({
    templateUrl: './customer-info.component.html',
    standalone: false
})
export class InstallationCustomerInfoPluginComponent {
  public plugin: any;
  public inspection: Inspection;
  public customer: any;
  public config: any;
  public anilox: any[];
  public editRoute = ['installation', 'customerinfo', 'edit'];

  constructor(private cdRef: ChangeDetectorRef, private service: InstallationCustomerInfoPluginService) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.inspection = inspection;
    this.plugin = plugin;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.service.getCountries().subscribe((data: any) => {
      this.customer = this.inspection.insptectionInspectionCustomer || null;
      this.cdRef.detectChanges();
    });
  }
}
PluginComponent.plugins['installationcustomerinfo'] = InstallationCustomerInfoPluginComponent;
